"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionSignalSchema = void 0;
const zod_1 = require("zod");
const IComponentFunctionSignalBase_1 = require("./IComponentFunctionSignalBase");
const RelativeSignal_1 = require("../RelativeSignal");
const IComponentFunctionSignalAttributes_1 = require("./IComponentFunctionSignalAttributes");
exports.IComponentFunctionSignalSchema = IComponentFunctionSignalBase_1.IComponentFunctionSignalBaseSchema.extend({
    signals: RelativeSignal_1.RelativeSignalSchema.array(),
    description: zod_1.z.string().optional(),
    classSignalDescription: zod_1.z.string().optional(),
    alternateNames: zod_1.z.string().array().optional(),
    maxAssignments: zod_1.z.number().optional(),
    physicalAttributes: IComponentFunctionSignalAttributes_1.IComponentFunctionSignalAttributesSchema.optional(),
});
//# sourceMappingURL=IComponentFunctionSignal.js.map